(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('PurchasedProductSearch', PurchasedProductSearch);

  PurchasedProductSearch.$inject = ['$resource', 'API_URI'];

  function PurchasedProductSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/purchased-products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
